import * as React from "react";

import { ColorPaletteSelector } from "Components/ColorPaletteSelector";

import { IQuiltParams } from "Model/IQuiltParams";
import { IColorPalette } from "Model/IColorPalette";
import { IBlockQuiltParams } from "Model/IBlockQuiltParams";
import { IGeneralQuiltParams } from "Model/IGeneralQuiltParams";
import { IColorPaletteReference } from "Model/IColorPaletteReference";

export interface IProps {
    readonly params: IQuiltParams;
    readonly palettes: IColorPalette[];

    readonly onGeneralParamsChanged: (p: IGeneralQuiltParams) => void;
    readonly onBlockParamsChanged: (p: IBlockQuiltParams) => void;
}

export function ColorEditor(props: IProps): React.ReactElement {
    const params = props.params;

    const onBackgroundPaletteChanged = (ref?: IColorPaletteReference) => {
        props.onGeneralParamsChanged({
            ...params.general,
            backgroundPaletteRef: ref
        });
    };

    const onBlockPaletteChanged = (ref?: IColorPaletteReference) => {
        props.onBlockParamsChanged({
            ...params.block,
            paletteRef: ref
        });
    };

    return (
        <form>
            <ColorPaletteSelector
                label="Background"
                palettes={props.palettes}
                selectedRef={params.general.backgroundPaletteRef}
                onSelectionChanged={onBackgroundPaletteChanged}/>
            <ColorPaletteSelector
                label="Block"
                palettes={props.palettes}
                selectedRef={params.block.paletteRef}
                onSelectionChanged={onBlockPaletteChanged}/>
        </form>
    )
}